module.exports = __webpack_public_path__ + "img/heart.b7769fc0.png";